import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';
import emitResize from '../../../utils/emitResize';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.CLOSE_ALL,
            types.SETTINGS,
            types.COMMUNICATION,
            types.SOURCE_CODE,
            types.ONLINE,
            types.HELP,
        ],
    }),
    [types.CLOSE_ALL](state) {
        state.communication = false;
        state.sourceCode = false;
        state.online = false;
        state.help = false;
        state.settings = false;

        emitResize();
    },
    [types.SETTINGS](state, payload) {
        state.communication = false;
        state.sourceCode = false;
        state.online = false;
        state.help = false;
        state.settings = payload;

        emitResize();
    },
    [types.COMMUNICATION](state, payload) {
        state.settings = false;
        state.sourceCode = false;
        state.online = false;
        state.help = false;
        state.communication = payload;

        emitResize();
    },
    [types.SOURCE_CODE](state, payload) {
        state.settings = false;
        state.communication = false;
        state.online = false;
        state.help = false;
        state.sourceCode = payload;

        emitResize();
    },
    [types.ONLINE](state, payload) {
        state.settings = false;
        state.communication = false;
        state.sourceCode = false;
        state.help = false;
        state.online = payload;

        emitResize();
    },
    [types.HELP](state, payload) {
        state.settings = false;
        state.communication = false;
        state.sourceCode = false;
        state.online = false;
        state.help = payload;

        emitResize();
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/mutations.js